module.exports = __webpack_public_path__ + "static/media/estabelecimentos-proximos-mobile.84b3e0e9.jpg";